import React from "react";
import { Button } from "primereact/button";
import type { ReportContext } from "../../../types/stationPerformance";
import { contextHeaderRows, downloadCsv } from "../utils/csv";

interface ExportCsvButtonProps {
  filename: string;
  title: string;
  context: ReportContext | null | undefined;
  /** Column headers, already escaped by the caller via `cell`. */
  headers: string[];
  /** Data rows, already escaped by the caller. */
  rows: string[][];
  disabled?: boolean;
}

/**
 * Exports a view's underlying figures with its reporting context in the header rows (FR-035).
 *
 * The context is not decoration. These numbers exist to be carried into board and investor analysis, and a
 * bare grid of figures cannot answer "per site or per connector?" a week after it was downloaded: which
 * is exactly how two people end up quoting the same file and disagreeing.
 */
const ExportCsvButton: React.FC<ExportCsvButtonProps> = ({
  filename,
  title,
  context,
  headers,
  rows,
  disabled = false,
}) => (
  <Button
    label="Export CSV"
    icon="pi pi-download"
    severity="secondary"
    outlined
    size="small"
    disabled={disabled || rows.length === 0}
    onClick={() => downloadCsv(filename, [...contextHeaderRows(title, context), headers, ...rows])}
  />
);

export default ExportCsvButton;
